import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';

const ResignationFormModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    last_working_day: new Date().toISOString().split('T')[0],
    reason_for_leaving: '',
    buy_out: false,
    served_notice_period: 0,
    department: 'IT',  // Set default department
    designation: 'Employee'  // Set default designation
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSubmit(formData);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg shadow-lg relative">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold">Submit Resignation</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
            disabled={loading}
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block font-medium mb-1">Last Working Day</label>
            <input
              type="date"
              value={formData.last_working_day}
              onChange={(e) => setFormData({ ...formData, last_working_day: e.target.value })}
              min={new Date().toISOString().split('T')[0]}
              className="w-full border rounded px-2 py-1"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Reason for Leaving</label>
            <textarea
              value={formData.reason_for_leaving}
              onChange={(e) => setFormData({ ...formData, reason_for_leaving: e.target.value })}
              rows={4}
              className="w-full border rounded px-2 py-1"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Notice Period Served (in days)</label>
            <input
              type="number"
              value={formData.served_notice_period}
              onChange={(e) => setFormData({ ...formData, served_notice_period: parseInt(e.target.value) })}
              min="0"
              className="w-full border rounded px-2 py-1"
              required
              disabled={loading}
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="buy_out"
              checked={formData.buy_out}
              onChange={(e) => setFormData({ ...formData, buy_out: e.target.checked })}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              disabled={loading}
            />
            <label htmlFor="buy_out" className="ml-2 block text-sm text-gray-900">
              I am willing to buy out my notice period
            </label>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Submitting...
                </div>
              ) : (
                'Submit Resignation'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResignationFormModal; 